import { render } from "./JCommentsBoard.Modal.vue?vue&type=template&id=770f5d38"
import script from "./JCommentsBoard.Modal.vue?vue&type=script&lang=js"
export * from "./JCommentsBoard.Modal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__